import {Component, input} from '@angular/core';
import {ActivityPreviewComponent} from '@domain/activity/component/activity-preview/activity-preview.component';
import {ActivityDTO, ActivityState} from '@domain/activity/activity.dto';

@Component({
  selector: 'app-activities-preview',
  imports: [
    ActivityPreviewComponent
  ],
  templateUrl: './activities-preview.component.html',
  styleUrl: './activities-preview.component.scss'
})
export class ActivitiesPreviewComponent {
  public readonly items = input.required<ActivityDTO[]>();
  public readonly isPublic = input.required<boolean>();
  public readonly showState = input(false);
  public readonly showHost = input(false);
  public readonly showDistance = input(false);
  public readonly showUnpublished = input(false);

  public readonly STATE_PUBLISHED = ActivityState.Published;
}
